import axios, { AxiosError } from 'axios';
import { Api } from '../../axios-config';

interface IDetalhesPonto{
  titulo: string;
  ponto: number;
  falta: number;
  atestado: number;
  horaextra: number;
  bomba: number;
  pistola: number;
  cafe: number;
  almoco: number;
  janta: number;
}

interface IResumoPonto{
  presenca:[], 
  falta:[],
  atestado:[],
    
  cafe:[],
  almoco:[],
  janta:[],
       
  horaextra:[], 
  bomba:[],
  pistola:[],

  detalhes: IDetalhesPonto[];
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (idfun: string, ano = ''): Promise<IResumoPonto | Error> => {
  try {
    const urlRelativa = `/pontoanual?idfun=${idfun}&ano=${ano}`;
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};


export const PontoAnualService = {
  getAll,
};